// OrderField contains logic to render a single
// label and text input
import React from "react";
export default (function (props) {
    var style = { marginBottom: "5px", opacity: 1, pointerEvents: "all" };
    if (props.type === "checkbox") {
        style.padding = "3px";
        style.height = 24;
        style.width = 24;
        style.marginRight = 20;
    }
    return (React.createElement("div", { className: "col s12 m6" },
        React.createElement("label", null, props.label + " "),
        React.createElement("input", { step: props.step, type: props.type, placeholder: props.placeholder, className: props.type === "checkbox" ? "checkbox" : undefined, style: style, name: props.label, onChange: function (e) { return props.onChange && props.onChange(e.target.value); }, value: props.type !== "checkbox" ? props.value : undefined, disabled: props.disabled, readOnly: props.readonly, checked: props.type === "checkbox" ? props.value : undefined }),
        React.createElement("div", { className: "red-text", style: { marginBottom: "20px" } }, props.meta && props.meta.touched && props.meta.error)));
});



//////////////////
// WEBPACK FOOTER
// ./src/components/common/InputField.tsx
// module id = 54
// module chunks = 0